import * as React from "react"
const TeacherIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill={props.color}
      d="M10 7.605a3.755 3.755 0 0 1-3.75-3.75A3.755 3.755 0 0 1 10 .105a3.755 3.755 0 0 1 3.75 3.75A3.755 3.755 0 0 1 10 7.605Zm9.102.568c-.572-.477-1.316-.673-2.097-.53l-3.435.836a3.332 3.332 0 0 0-2.737 3.28v6.502l-.833.151-.833-.151v-6.502c0-1.613-1.151-2.991-2.69-3.27l-3.53-.856a2.483 2.483 0 0 0-2.049.54A2.491 2.491 0 0 0 0 10.093v8.194l10 1.819 10-1.819v-8.195c0-.743-.328-1.442-.898-1.919Z"
    />
  </svg>
)
export default TeacherIcon

